/**
 * Tenant configuration — controls which menu items and routes are visible
 * based on the current domain/subdomain.
 *
 * Values: array of menu item IDs from Sidebar.jsx menuItems
 * Available IDs: chat, chart, screener, history, watchlist, portfolio, alerts, blog
 */
export const TENANT_MENU = {
  default: [
    'home',
    'chart',
    'watchlist',
    'portfolio',
    'alerts',
    'blog',
  ],
  app: [
    'chat',
    'chart',
    'screener',
    'history',
    'watchlist',
    'portfolio',
    'alerts',
    'blog',
  ],
};

/**
 * Maps menu item IDs to their route paths.
 * Keep in sync with Sidebar.jsx menuItems and App.jsx routes.
 */
export const MENU_PATHS = {
  chat:               '/chat',
  chart:              '/chart',
  screener:           '/screener',
  history:            '/history',
  watchlist:          '/watchlist',
  portfolio:          '/portfolio',
  alerts:             '/alerts',
  blog:               '/blog',
};

/**
 * Returns the allowed menu IDs for a given subdomain.
 * Falls back to 'default' if the subdomain has no config entry.
 */
export function getAllowedMenuIds(subdomain) {
  return TENANT_MENU[subdomain] ?? TENANT_MENU.default;
}

/**
 * Returns the home path for a given subdomain.
 */
export function getHomePath() {
  // Signed-in users land in the chat.
  return '/agentbro';
}
